import { parse } from 'papaparse'
import { readCSVFile } from '@/models/readCSVFileUtil'
import { LocationRepository } from '@/models/Location'
import LocationModel from './Location'
import uniqWith from 'lodash/uniqWith'
import _isEqual from 'lodash/isEqual'
import { extractImportableAndErrorLocations } from '@/models/Location/ExtractImportableAndErrorLocationsForLocationBulk'

export default class BulkAddLocationFormModel {
  constructor({ locationGroup, geocoder }) {
    this.locationGroup = locationGroup
    this.geocoder = geocoder
    this.csv = ''
  }

  get parseAndDistinctLocations() {
    // csvから取得し、重複を排除
    const parseLocations = uniqWith(parseCSV(this.csv), _isEqual)
    // 何も入力されていない行を排除してから返す
    return parseLocations.filter(location => {
      if (
        (location.name === undefined || location.name === '') &&
        (location.address === undefined || location.address === '')
      )
        return false
      return true
    })
  }

  async readCSVFile(file) {
    const text = await readCSVFile(file)
    this.errorLocationCsv = ''
    // 2カラムのみ読み込み、かつ何も入力されてない場合空文字にreplace
    this.csv = parse(text)
      .data.map(([locationName, address]) => {
        const validLocationName = (() => {
          if (locationName === undefined) return ''
          return locationName
        })()
        const validAddress = (() => {
          if (address === undefined) return ''
          return address
        })()
        return `${validLocationName},${validAddress}`
      })
      .join(`\n`)
      .trim()
      .replace('undefined', '')
  }

  async save() {
    const locationGroupId = this.locationGroup.id
    const geocoder = this.geocoder
    const parsedLocations = this.parseAndDistinctLocations
    const locations = await extractImportableAndErrorLocations({
      parsedLocations,
      geocoder,
    })
    if (locations.errorLocations.length > 0) {
      const error = new Error(
        `上記の${locations.errorLocations.length}地点が正しいフォーマットではないもしくは、住所を座標へ変換できないため登録できません。\n上記の地点（エラー地点）を登録する場合、情報を修正のうえ下記の入力欄（入稿地点一覧）へ追記のうえ再度登録ボタンを押してください。\n上記の地点を登録しない場合、そのまま再度登録ボタンを押してください。`,
      )
      error.locations = locations
      throw error
    }
    const importableLocations = locations.importableLocations
    const importLocations = await Promise.all(
      importableLocations.map(async ({ name, address }) => {
        const latLng = await this.geocoder(address)
        const { lat, lng } = latLng[0]
        const location = new LocationModel({
          locationGroupId,
          name,
          shapeType: 'point',
          shape: {
            latitude: lat,
            longitude: lng,
          },
        })
        location.newItem = { new: true }
        return location
      }),
    )
    await LocationRepository.saveBulkCustomLocations(
      locationGroupId,
      importLocations,
    )
    return true
  }
}

/**
 *
 * @param {string} csv
 * @return {{ name: string, address: string }[]}
 */
const parseCSV = csv => {
  const result = parse(csv)
  return result.data.map(([name, address]) => ({
    name,
    address,
  }))
}
